import { SinglePaymentCriteria } from '@nemuru-eng/js-api-client';

import { SinglePaymentStatusLabel } from '@/components/modules/SinglePaymentListByProduct/components/SinglePaymentStatusLabel';
import { Text } from '@/components/shared/components/Text';

export const statusFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.53,
    field: 'status',
    headerName: <Text tId={'STATUS'} />,
    renderCell: (rowData: { row: SinglePaymentCriteria }) => (
      <div
        style={{
          minWidth: '120px',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          whiteSpace: 'break-spaces',
          width: '100%',
        }}
      >
        <SinglePaymentStatusLabel status={rowData.row.status} />
      </div>
    ),
  };
};
